import { render, staticRenderFns } from "./Notifications_Realtime_Popup.vue?vue&type=template&id=1983fee3&scoped=true&"
import script from "./Notifications_Realtime_Popup.vue?vue&type=script&lang=js&"
export * from "./Notifications_Realtime_Popup.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_Realtime_Popup.vue?vue&type=style&index=0&id=1983fee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983fee3",
  null
  
)

export default component.exports